// extracted by mini-css-extract-plugin
export default {"li":"ManualWeakConnectorUpgradeDialog_li__sKLih"};